import Link from "next/link";
import { Button } from "@repo/ui/components/ui/button";
import { useTranslations } from "next-intl";

const HelpPageContactLink = ({
  contactFormLink,
}: {
  contactFormLink: string;
}) => {
  const t = useTranslations("SharedHelp");

  return (
    <div className="-m-[40px] max-md:-m-6 p-10 flex flex-col justify-center items-center linear-gradient-help">
      <h4>{t("contact-form-title")}</h4>
      <Link href={contactFormLink}>
        <Button className="max-w mt-10 max-md:mt-6 max-md:w-full">
          {t("contact-button-text")}
        </Button>
      </Link>
    </div>
  );
};

export default HelpPageContactLink;
